export default __webpack_public_path__ + "ae0389f1e3cec89d645f5685fc1a24a3.svg";